import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ErrorBoundary } from "./components/ErrorBoundary";
import Directory from "./pages/Directory";
import AthleteProfile from "./pages/AthleteProfile";
import Login from "./pages/Login";
import AuthCallback from "./pages/AuthCallback";
import AdminDashboard from "./pages/AdminDashboard";

const ProtectedAdmin = () => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen p-10 label-mono">Verifying access…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (!user.is_admin)
    return (
      <div className="min-h-screen flex items-center justify-center p-10 text-center" data-testid="no-admin-access">
        <div>
          <h1 className="font-display text-5xl">Access denied</h1>
          <p className="text-sm text-zinc-400 mt-4">
            This account is not authorized to manage athlete profiles.
          </p>
        </div>
      </div>
    );
  return <AdminDashboard />;
};

const AppRouter = () => {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Directory />} />
      <Route path="/athletes/:slug" element={<AthleteProfile />} />
      <Route path="/login" element={<Login />} />
      <Route path="/admin" element={<ProtectedAdmin />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ErrorBoundary>
          <AppRouter />
        </ErrorBoundary>
        <Toaster theme="dark" position="top-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}
